"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJSON = exports.getUrl = void 0;
const getUrl = (uri, gateway = 'cloudflare-ipfs.com') => {
    const ipfsGateway = `https://${gateway}`;
    if (!uri)
        return null;
    if (!uri.startsWith('ipfs://') &&
        !uri.startsWith('ipns://') &&
        !uri.startsWith('https://') &&
        !uri.startsWith('http://'))
        return `${ipfsGateway}/ipfs/${uri}`;
    const uriScheme = uri.split('://')[0];
    if (uriScheme === 'ipfs')
        return uri.replace('ipfs://', `${ipfsGateway}/ipfs/`);
    if (uriScheme === 'ipns')
        return uri.replace('ipns://', `${ipfsGateway}/ipns/`);
    return uri;
};
exports.getUrl = getUrl;
const getJSON = async (uri) => {
    const url = (0, exports.getUrl)(uri);
    if (url) {
        const res = await fetch(url);
        return res.json();
    }
};
exports.getJSON = getJSON;
